import { render, staticRenderFns } from "./dhPopup.vue?vue&type=template&id=0df4e314&scoped=true"
import script from "./dhPopup.vue?vue&type=script&lang=js"
export * from "./dhPopup.vue?vue&type=script&lang=js"
import style0 from "./dhPopup.vue?vue&type=style&index=0&id=0df4e314&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df4e314",
  null
  
)

export default component.exports